module.exports = {
      id: "update-black-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#update-black",
      toString: function () {
        return this.url;
      }
    }